/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import stopReadAloudIcon from "dc-icons/viewer2021/S_CrossMedium_18_N.svg";
import * as constants from "constants/constants";
import ReadAloudCss from "components/readAloud/readAloud.css";

const mapStoresToProps = stores => ({
  icon: stopReadAloudIcon,
  className: ReadAloudCss.close,
  ariaLabel: "arialabel.readAloudStop",
  tooltipString: "tooltip.readAloudStop",
  tooltipPlacement: constants.TOOLTIP_BOTTOM_PLACEMENT,
  tooltipDelay: constants.TOOLTIP_DELAY,
  shouldEnableHover: true,
  clickHandler: () => stores.readAloudStore.stopHandler()
});

export const ReadAloudStopContainer = inject(mapStoresToProps)(ButtonWrapper);
